export type RamFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type RamFilterGroup = {
  id: string;
  label: string;
  options: RamFilterOption[];
};

export const ramFilterGroups: RamFilterGroup[] = [
  {
    id: 'brand',
    label: 'Hãng',
    options: [
      { value: 'corsair', label: 'Corsair', keywords: ['corsair'] },
      { value: 'gskill', label: 'G.Skill', keywords: ['g.skill', 'gskill'] },
      { value: 'kingston', label: 'Kingston', keywords: ['kingston'] },
      { value: 'adata', label: 'ADATA', keywords: ['adata'] },
      { value: 'teamgroup', label: 'TeamGroup', keywords: ['teamgroup', 'team group'] },
      { value: 'patriot', label: 'Patriot', keywords: ['patriot'] },
      { value: 'lexar', label: 'Lexar', keywords: ['lexar'] },
      { value: 'pny', label: 'PNY', keywords: ['pny'] },
      { value: 'apacer', label: 'Apacer', keywords: ['apacer'] },
      { value: 'geil', label: 'GeIL', keywords: ['geil'] },
      { value: 'silicon-power', label: 'Silicon Power', keywords: ['silicon power'] },
      { value: 'samsung', label: 'Samsung', keywords: ['samsung'] },
    ],
  },
  {
    id: 'type',
    label: 'Loại RAM',
    options: [
      { value: 'ddr3', label: 'DDR3', keywords: ['ddr3'] },
      { value: 'ddr4', label: 'DDR4', keywords: ['ddr4'] },
      { value: 'ddr5', label: 'DDR5', keywords: ['ddr5'] },
    ],
  },
  {
    id: 'device',
    label: 'Thiết bị',
    options: [
      { value: 'pc', label: 'PC', keywords: ['pc'] },
      { value: 'laptop', label: 'Laptop', keywords: ['laptop', 'so-dimm', 'sodimm'] },
    ],
  },
  {
    id: 'sticks',
    label: 'Số thanh',
    options: [
      { value: '1', label: '1 thanh', keywords: ['1 thanh', 'single', '1x'] },
      { value: '2', label: '2 thanh', keywords: ['2 thanh', 'dual', '2x'] },
    ],
  },
  {
    id: 'led',
    label: 'LED',
    options: [
      { value: 'rgb', label: 'RGB', keywords: ['rgb'] },
      { value: 'non-led', label: 'Không LED', keywords: ['non led', 'khong led', 'no led'] },
    ],
  },
  {
    id: 'capacity',
    label: 'Dung lượng',
    options: [
      { value: '4gb', label: '4GB', keywords: ['4gb', '4 gb'] },
      { value: '8gb', label: '8GB', keywords: ['8gb', '8 gb'] },
      { value: '16gb', label: '16GB', keywords: ['16gb', '16 gb'] },
      { value: '32gb', label: '32GB', keywords: ['32gb', '32 gb'] },
      { value: '64gb', label: '64GB', keywords: ['64gb', '64 gb'] },
      { value: '128gb', label: '≥128GB', keywords: ['128gb', '128 gb', '256gb', '256 gb'] },
    ],
  },
  {
    id: 'bus',
    label: 'Bus',
    options: [
      { value: '1333', label: '1333 MHz', keywords: ['1333'] },
      { value: '1600', label: '1600 MHz', keywords: ['1600'] },
      { value: '2400', label: '2400 MHz', keywords: ['2400'] },
      { value: '2666', label: '2666 MHz', keywords: ['2666'] },
      { value: '3000', label: '3000 MHz', keywords: ['3000'] },
      { value: '3200', label: '3200 MHz', keywords: ['3200'] },
      { value: '3600', label: '3600 MHz', keywords: ['3600'] },
      { value: '4800', label: '4800 MHz', keywords: ['4800'] },
      { value: '5200', label: '5200 MHz', keywords: ['5200'] },
      { value: '5600', label: '5600 MHz', keywords: ['5600'] },
      { value: '6000', label: '6000 MHz', keywords: ['6000'] },
      { value: '6400', label: '6400 MHz', keywords: ['6400'] },
    ],
  },
];
